export default "__VITE_ASSET__CRcis99l__"